/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Oneglue_Key_Revoked_DescInputs */



/**
* | output |
* | --- |
* | "A member's oneGlue inference key was revoked." |
*
* @param {Audit_Details_Oneglue_Key_Revoked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_oneglue_key_revoked_desc = /** @type {((inputs?: Audit_Details_Oneglue_Key_Revoked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Oneglue_Key_Revoked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der oneGlue-Inferenz-Schlüssel eines Mitglieds wurde widerrufen.")
	return /** @type {LocalizedString} */ ("A member's oneGlue inference key was revoked.")
});